<template>
  <v-container fluid class="tp-page">
    <template v-if="!addUser">
      <!-- Cabeçalho -->
      <div class="tp-page-head">
        <div>
          <h1 class="tp-page-title">Profissionais</h1>
          <p class="tp-page-sub">{{ tabela.conteudo.length }} no total</p>
        </div>
        <div class="tp-head-actions">
          <v-text-field v-model="tabela.busca" prepend-inner-icon="mdi-magnify" placeholder="Buscar…" hide-details dense outlined color="#00695C" class="tp-search"></v-text-field>
          <v-tooltip bottom v-if="user && user.igrejaId && user.igrejaId !== '6390de5538a3bc18300a2022'">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="#00695C" outlined depressed rounded v-on="on" v-bind="attrs" @click="abrirLinkPublico('/cadastro-profissional')">
                <v-icon>mdi-open-in-new</v-icon>
              </v-btn>
            </template>
            <span>Abrir link público de cadastro de profissional</span>
          </v-tooltip>
          <v-btn color="#00695C" dark depressed rounded class="tp-btn-add" @click="criarNovo">
            <v-icon left>mdi-plus-circle-outline</v-icon>Cadastrar
          </v-btn>
        </div>
      </div>

      <!-- Tabela -->
      <v-card class="tp-card" elevation="0">
        <v-data-table :search="tabela.busca" :headers="tabela.cabecalho" :items="tabela.conteudo" sort-desc>
          <template v-slot:[`item.action`]="{ item }">
            <v-icon small class="mr-3" color="#00695C" @click="editItem(item)">edit</v-icon>
            <v-icon small color="error" @click="deleteItem(item)">delete</v-icon>
          </template>
          <template v-slot:[`item.ativo`]="{ item }">
            <v-icon v-if="item.ativo == true" color="success">circle</v-icon>
            <v-icon v-else color="error">circle</v-icon>
          </template>
          <template v-slot:[`item.cor`]="{ item }">
            <v-card :color="item.cor">
              <p :style="`color:${item.cor}; margin: 0px`">{{ item.cor }}</p>
            </v-card>
          </template>
          <template v-slot:no-data>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Nenhum profissional encontrado</v-alert>
          </template>
          <template v-slot:no-results>
            <v-alert dense text outlined :value="true" color="warning" icon="info" class="ma-3">Sua pesquisa por "{{ tabela.busca }}" não trouxe resultados</v-alert>
          </template>
        </v-data-table>
      </v-card>
    </template>

    <v-card v-else class="tp-card tp-form" elevation="0">
      <v-card-title>
        <span class="tp-serif" style="font-size:1.25rem;color:#00253E;font-weight:600">{{ formTitle }}</span>
        <v-spacer></v-spacer>
        <p style="font-size:15px; color:#00695C"> *O preenchimento de todos os campos é obrigatório</p>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-autocomplete v-model="editedItem.membroId" :items="membros" item-text="nome" item-value="id" hide-details
              outlined label="Nome" color="#00695C"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-autocomplete v-model="editedItem.servicos" :items="servicosDisponiveis" item-text="nome"
              item-value="codigo" multiple chips hide-details outlined label="Serviços Oferecidos"
              color="#00695C"></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="editedItem.telefone" outlined label="WhatsApp com DDD" color="#00695C" type="tel"
              v-mask="'(##) #####-####'"></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <v-text-field v-model="editedItem.cpf" outlined label="CPF" color="#00695C" readonly></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field v-model="editedItem.celula" outlined label="Célula" color="#00695C" readonly></v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="px-4 pb-4">
        <v-spacer></v-spacer>
        <v-btn color="#00695C" text large @click="close">Cancelar</v-btn>
        <v-btn color="#00695C" dark depressed rounded large class="tp-btn-add px-6" @click="save">Salvar</v-btn>
      </v-card-actions>
    </v-card>
    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </v-container>
</template>

<script>
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
import { baseApiUrl } from '@/global'
import moment from 'moment'
import Snackbar from '../componentes/snackbar.vue'
import axios from 'axios'
import { mapState } from 'vuex'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

export default {
  components: { Snackbar, Loading, Swatches },
  data: () => ({
    fullPage: true,
    isLoading: false,
    addUser: false,
    tabela: {
      busca: '',
      cabecalho: [
        { text: 'Nome', align: 'start', value: 'nome' },
        { text: 'Serviços', value: 'servicosFormatados' },
        { text: 'CPF', value: 'cpf' },
        { text: 'Célula', value: 'celula' },
        { text: 'Telefone', value: 'telefone' },
        { text: 'Ações', value: 'action', align: 'center', sortable: false },
      ],
      conteudo: []
    },
    editedIndex: -1,
    editedItem: {
      membroId: '',
      servicos: [],
      telefone: null,
      cpf: null,
      celula: null,
    },
    defaultItem: {
      membroId: '',
      servicos: [],
      telefone: null,
      cpf: null,
      celula: null,
    },
    servicosData: [],
    membrosData: [],
    celulasData: [],
  }),

  computed: {
    ...mapState({
      usuarioLogado: state => state.isMenuVisible,
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),
    formTitle() {
      return this.editedIndex === -1 ? 'ADICIONAR NOVO PROFISSIONAL' : 'EDITAR PROFISSIONAL'
    },
    servicosDisponiveis() {
      return this.servicosData.map(servico => ({
        nome: servico.nome,
        codigo: servico.codigo,
      }));
    },
    membros() {
      return this.membrosData.map(membro => ({
        nome: membro.nome,
        id: membro.id,
        cpf: membro.cpf,
        celulaId: membro.celulaId,
        telefone: membro.telefone,
        recadastramento: membro.recadastramento,
      }));
    },
  },

  watch: {
    'editedItem.membroId': {
      async handler(newVal, oldVal) {
        if (newVal) {
          const membroSelecionado = this.membros.find(m => m.id === newVal);
          if (membroSelecionado) {
            this.editedItem.cpf = membroSelecionado.cpf || null;
            this.editedItem.telefone = membroSelecionado.telefone || null;

            const celula = this.celulasData.find(c => c.id === membroSelecionado.celulaId);
            this.editedItem.celula = celula ? celula.nome : null;

            if (this.editedIndex === -1 || newVal !== oldVal) {
              const profissionalExistente = this.tabela.conteudo.find(p => p.membroId === newVal);
              if (profissionalExistente) {
                this.editedItem.servicos = profissionalExistente.servicosCodigos;
                this.editedItem.id = profissionalExistente.id;
                this.editedIndex = this.tabela.conteudo.indexOf(profissionalExistente);
              } else {
                this.editedItem.servicos = [];
                this.editedItem.id = null;
                this.editedIndex = -1;
              }
            }
          } else {
            this.editedItem.cpf = null;
            this.editedItem.telefone = null;
            this.editedItem.celula = null;
            this.editedItem.servicos = [];
            this.editedItem.id = null;
            this.editedIndex = -1;
          }
        } else {
          this.editedItem.cpf = null;
          this.editedItem.telefone = null;
          this.editedItem.celula = null;
          this.editedItem.servicos = [];
          this.editedItem.id = null;
          this.editedIndex = -1;
        }
      },
      immediate: false
    }
  },

  async mounted() {
    await this.carregaCelulas();
    await this.carregaServicos();
    await this.carregaMembros();
    await this.carregaProfissionais();
  },

  methods: {
    abrirLinkPublico(rota) {
      const id = this.user && this.user.igrejaId ? this.user.igrejaId : ''
      if (id) window.open(`${window.location.origin}${rota}?igrejaId=${id}`, '_blank')
    },

    async carregaCelulas() {
      try {
        this.isLoading = true;
        const response = await axios.get(baseApiUrl + 'Celulas?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'));
        this.celulasData = response.data;
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar células.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    async carregaServicos(jaImportou) {
      try {
        this.isLoading = true;
        const response = await axios.get(baseApiUrl + 'ServicoProfissionals?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}, "order":"nome ASC"}&access_token=' + sessionStorage.getItem('accToken'));
        this.servicosData = response.data;

        // Rede de segurança: se a igreja ainda não tem serviços, importa o catálogo
        // padrão automaticamente (uma única vez) e recarrega. O backend ignora a
        // Igreja da Liberdade, que já possui seu catálogo.
        if (!jaImportou && (!this.servicosData || this.servicosData.length === 0) && this.user && this.user.igrejaId && this.user.igrejaId !== '6390de5538a3bc18300a2022') {
          try {
            await axios.post(`${baseApiUrl}ServicoProfissionals/importarPadrao?access_token=${sessionStorage.getItem('accToken')}`, { igrejaId: this.user.igrejaId });
            await this.carregaServicos(true);
          } catch (e) {
            // Silencioso: se falhar, o admin ainda pode cadastrar serviços manualmente.
          }
        }
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar serviços.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    async carregaMembros() {
      try {
        this.isLoading = true;
        let filter = {
          where: {
            igrejaId: this.user.igrejaId
          },
          order: 'nome ASC'
        };

        if (this.user.tipo === 'GERENTE') {
          filter.where.recadastramento = true;
        }

        const response = await axios.get(baseApiUrl + 'Membros?filter=' + encodeURIComponent(JSON.stringify(filter)) + '&access_token=' + sessionStorage.getItem('accToken'));
        this.membrosData = response.data;
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar membros.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    async carregaProfissionais() {
      this.isLoading = true;
      try {
        const response = await axios.get(baseApiUrl + 'Profissionais?filter={"where":{"igrejaId":"' + this.user.igrejaId + '"}}&access_token=' + sessionStorage.getItem('accToken'));
        let profissionais = response.data;

        if (this.user.tipo === 'GERENTE') {
          profissionais = profissionais.filter(profissional => {
            const membro = this.membrosData.find(m => m.id === profissional.membroId);
            return membro && membro.recadastramento === true;
          });
        }

        this.tabela.conteudo = profissionais.map(profissional => {
          const membro = this.membrosData.find(m => m.id === profissional.membroId);

          let nomeCelula = null;
          if (membro && membro.celulaId) {
            const celula = this.celulasData.find(c => c.id === membro.celulaId);
            nomeCelula = celula ? celula.nome : null;
          }

          const servicosNomesFormatados = profissional.servicos
            .map(codigo => {
              const servico = this.servicosData.find(s => s.codigo === codigo);
              return servico ? servico.nome : null;
            })
            .filter(Boolean)
            .join(', ');

          return {
            ...profissional,
            nome: membro ? membro.nome : null,
            cpf: membro ? membro.cpf : null,
            celula: nomeCelula,
            telefone: membro ? membro.telefone : null,
            servicosCodigos: profissional.servicos,
            servicosFormatados: servicosNomesFormatados,
          };
        });
      } catch (error) {
        this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao carregar profissionais.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    criarNovo() {
      this.addUser = true;
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },

    editItem(item) {
      this.editedIndex = this.tabela.conteudo.indexOf(item);
      this.editedItem = {
        ...Object.assign({}, item),
        servicos: item.servicosCodigos,
        telefone: item.telefone,
        cpf: item.cpf,
        celula: item.celula,
      };
      this.addUser = true;
    },

    async deleteItem(item) {
      var r = confirm('Deseja realmente excluir o profissional: ' + (item.nome || 'este profissional') + '?')
      if (r == true) {
        this.isLoading = true
        try {
          await axios.delete(`${baseApiUrl}Profissionais/${item.id}?access_token=${sessionStorage.getItem('accToken')}`)
          this.$refs.chamaSnackbar.snack("#0288D1", "Operação realizada com sucesso!", "INFORMAÇÃO")
          await this.carregaProfissionais()
        } catch (error) {
          console.error("Erro ao excluir profissional:", error);
          this.$refs.chamaSnackbar.snack("#EF5350", "Erro ao realizar operação, tente novamente", "ERRO");
        } finally {
          this.isLoading = false;
        }
      }
    },

    close() {
      this.addUser = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },

    async save() {
      this.isLoading = true;
      var vm = this;

      if (!this.editedItem.membroId || !this.editedItem.servicos || this.editedItem.servicos.length === 0) {
        this.isLoading = false;
        vm.$refs.chamaSnackbar.snack("#0288D1", "Por favor, selecione um membro e pelo menos um serviço.", "INFORMAÇÃO");
        return;
      }

      const profissionalParaSalvar = {
        igrejaId: this.user.igrejaId,
        membroId: this.editedItem.membroId,
        servicos: this.editedItem.servicos,
      };

      try {
        if (this.editedIndex !== -1 && this.editedItem.id) {
          await axios.patch(`${baseApiUrl}Profissionais/${this.editedItem.id}?access_token=${sessionStorage.getItem('accToken')}`, profissionalParaSalvar);
          vm.$refs.chamaSnackbar.snack("#0288D1", "Profissional atualizado com sucesso!", "INFORMAÇÃO");
        } else {
          await axios.post(`${baseApiUrl}Profissionais/replaceOrCreate?access_token=${sessionStorage.getItem('accToken')}`, profissionalParaSalvar);
          vm.$refs.chamaSnackbar.snack("#0288D1", "Profissional cadastrado com sucesso!", "INFORMAÇÃO");
        }
        await this.carregaProfissionais();
        this.close();
      } catch (error) {
        vm.$refs.chamaSnackbar.snack("#EF5350", "Erro ao salvar profissional, tente novamente.", "ERRO");
      } finally {
        this.isLoading = false;
      }
    },

    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDateBrz(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatDatePadrao(date) {
      if (!date) return null
      const [day, month, year] = date.substr(0, 10).split('/')
      return `${year}-${month}-${day}` + " " + date.substr(11, 6)
    },
    formatDateHora(date) {
      if (!date) return null
      const [year, month, day] = date.substr(0, 10).split('-')
      return `${day}/${month}/${year}` + " " + date.substr(11, 8)
    },
    doCopy(id) {
      try {
        let copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        this.snackbar = true
        this.textoSnackbar = 'Chave copiada para a área de transferência!'
      } catch (error) {
        this.snackbar = true
        this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
      }
    },
    compare(a) {
      const dataA = moment(this.formatDateHora(a.fim), 'DD/MM/YYYY HH:mm:ss', true).format()
      const dataC = moment().format()
      let comparison = 0;
      if (dataC >= dataA) {
        comparison = 1;
      } else if (dataC < dataA) {
        comparison = -1;
      }
      return comparison;
    },
  },
}
</script>

<style>
.textoUser {
  font-weight: bold;
  color: #00253E;
  font-size: 17px;
}

@font-face {
  font-family: Roboto;
  src: url('https://fonts.google.com/specimen/Roboto');
}

.cssBotao {
  font-weight: bold;
  border-radius: 8px;
  width: 150px;
  font-size: 7px;
}

.theme--light.v-data-table thead tr th {
  color: white;
}
</style>